// extracted by mini-css-extract-plugin
module.exports = {"testResult":"TestResult_testResult__2uk5e"};